import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useT } from "@/i18n/i18n";
import api from "@/lib/api";
import { SectionHeading } from "@/components/shared";
import { Printer, ArrowRight } from "lucide-react";

export default function Investors() {
  const { t, lang } = useT();
  const [content, setContent] = useState(null);
  const L = (pl, en) => (lang === "pl" ? pl : en);

  useEffect(() => {
    api.get("/settings/public").then((r) => setContent(r.data.investor_content)).catch(() => {});
  }, []);

  const risks = [
    L("Adopcja przez rolników", "Farmer adoption"), L("Adopcja przez nabywców", "Buyer adoption"),
    L("Opóźnienia w zamówieniach publicznych", "Public procurement delays"), L("Odpowiedzialność za bezpieczeństwo żywności", "Food-safety liability"),
    L("Zmienność sezonowa", "Seasonal volatility"), L("Zapotrzebowanie na kapitał obrotowy", "Working-capital requirements"),
    L("Konflikt w ładzie korporacyjnym", "Governance conflict"), L("Koszty logistyki", "Logistics cost"),
    L("Regulacje i pomoc publiczna", "Regulatory & state-aid"), L("Oszustwa i cyberbezpieczeństwo", "Fraud & cybersecurity"),
  ];

  return (
    <div>
      <section className="border-b border-subtle bg-forestdark">
        <div className="mx-auto flex max-w-7xl flex-wrap items-end justify-between gap-4 px-4 py-16">
          <div className="max-w-2xl">
            <h1 className="font-heading text-3xl font-bold text-white sm:text-4xl lg:text-5xl">{L("Inwestorzy i partnerzy", "Investors & partners")}</h1>
            <p className="mt-4 text-lg text-white/80">{L("Wiarygodny pilotaż i krajowa wizja dla farmersko zakorzenionego systemu żywności.", "A credible pilot and national vision for a farmer-rooted food system.")}</p>
          </div>
          <button onClick={() => window.print()} data-testid="print-investor" className="inline-flex items-center gap-2 rounded-md border border-white/40 px-4 py-2.5 text-sm font-semibold text-white hover:bg-white/10">
            <Printer className="h-4 w-4" aria-hidden="true" /> {L("Drukuj podsumowanie", "Print summary")}
          </button>
        </div>
      </section>

      <div className="mx-auto max-w-4xl px-4 py-16">
        <div className="space-y-10">
          {(content?.sections || []).map((s) => (
            <div key={s.key} data-testid={`investor-section-${s.key}`}>
              <h2 className="font-heading text-xl font-bold text-charcoal sm:text-2xl">{s.title}</h2>
              <p className="mt-3 leading-relaxed text-mutedtext">{s.body}</p>
            </div>
          ))}
        </div>

        {content?.use_of_funds && (
          <div className="mt-14">
            <SectionHeading eyebrow={L("Wykorzystanie środków", "Use of funds")} title={L("Wykorzystanie środków (ilustracyjne)", "Use of funds (illustrative)")} />
            <div className="mt-6 space-y-3">
              {content.use_of_funds.map((u) => (
                <div key={u.label}>
                  <div className="flex justify-between text-sm text-charcoal"><span>{u.label}</span><span className="font-semibold">{u.pct}%</span></div>
                  <div className="mt-1 h-2 rounded-full bg-secondary"><div className="h-2 rounded-full bg-forest" style={{ width: `${u.pct}%` }} /></div>
                </div>
              ))}
            </div>
          </div>
        )}

        <div className="mt-14">
          <SectionHeading eyebrow={L("Ryzyko", "Risk")} title={L("Rejestr ryzyka", "Risk register")} />
          <div className="mt-6 grid gap-3 sm:grid-cols-2">
            {risks.map((r) => (<div key={r} className="rounded-md border border-subtle bg-white p-4 text-sm text-charcoal">{r}</div>))}
          </div>
        </div>

        <div className="mt-14 rounded-md border border-forest/20 bg-forest/5 p-6">
          <p className="text-sm text-charcoal">{t("footer.disclaimer")}</p>
          <Link to="/contact" className="mt-4 inline-flex items-center gap-2 rounded-md bg-forest px-4 py-2.5 text-sm font-semibold text-white hover:bg-forestdark">{t("cta.becomePartner")} <ArrowRight className="h-4 w-4" /></Link>
          <Link to="/strawberry-brief" data-testid="open-brief" className="mt-4 ml-3 inline-flex items-center gap-2 rounded-md border border-forest px-4 py-2.5 text-sm font-semibold text-forest hover:bg-forest/5">Truskawka 2027 Brief <ArrowRight className="h-4 w-4" /></Link>
        </div>
      </div>
    </div>
  );
}
